// 1. THE MAPPING (The "Jigsaw Link")
export const SEC_03_initialCapabilityRow = {
    roleId: 0,
    divisionCode: "",
    capabilityId: 0,
    isGranted: false
};

// 🎯 2. THE DEFINITION (The "Dictionary Entry")
// This mirrors your C# CapabilityDiscoveryRow
export const SEC_03_initialCapabilityDefinition = {
    capabilityId: 0,
    capabilityCode: "",
    capabilityName: "",
    description: "",
    isActive: true
};